const ENABLE_SENTRY = process.env.VUE_APP_ENABLE_SENTRY === 'true';
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
const SENTRY_ENV = (process.env.VUE_APP_SENTRY_ENV) ? process.env.VUE_APP_SENTRY_ENV : 'staging';

if (ENABLE_SENTRY) {
  if (!SENTRY_DSN) {
    throw new Error('VUE_APP_SENTRY_DSN is not set .env');
  }
}
const config = {
  api: {
    baseURL: process.env.VUE_APP_RESTO_BASE_URL,
    csvURL: process.env.VUE_APP_RESTO_CSV_URL,
    imageURL: process.env.VUE_APP_RESTO_IMAGE_URL,
  },
  PERMISSIONS: {
    CAN_CRUD_ROLES: 'can_crud_roles',
    CAN_CRUD_USERS: 'can_crud_users',
    CAN_CRUD_PERMISSIONS: 'can_crud_permissions',
    CAN_CRUD_ORDERS: 'can_crud_orders',
    CAN_CRUD_HISTORIES: 'can_crud_histories',
    CAN_ACCEPT_ORDER: 'can_accept_order',
    CAN_CRUD_MY_RESTAURANT: 'can_crud_my_restaurant',
    CAN_SEE_ACTIVITY_LOGS: 'can_see_activity_logs',
    CAN_CRUD_MENUS: 'can_crud_menus',
    IS_RESTO_ADMIN: 'is_resto_admin',
  },
  ENABLE_SENTRY,
  SENTRY_DSN,
  SENTRY_ENV,
  FIREBASE: {
    apiKey: 'AIzaSyD7xKkZOe9nMlXbibWk4Fot5NtDsyweSQ0',
    authDomain: 'resto-prod-9ca32.firebaseapp.com',
    projectId: 'resto-prod-9ca32',
    storageBucket: 'resto-prod-9ca32.appspot.com',
    messagingSenderId: '775249175501',
    appId: '1:775249175501:web:5f9baffd3e1f81be5c5a84',
    measurementId: 'G-CJK4WX8XXM',
  },
  VAPID_KEY: process.env.VUE_APP_VAPID_KEY,
};

export default config;
